import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Placeholder from '../../../common/placeholder/Placeholder';
import MusicItem from '../containers/MusicItemContainer';

const MusicItemShortcodeComponent = (props) => {
    // @TODO: check how to prefetch the music content if not saving it in the store?!

    const [musicItemData, setMusicItemData] = useState({
        music: false,
        playlistData: false,
    });

    useEffect(() => {
        props.getMusicData(props.artistSlug, props.musicSlug)
            .then((musicData) => {
                setMusicItemData({
                    music: musicData,
                    playlistData: [musicData],
                });
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.error('Problem when fetching music data: ', error);

                setMusicItemData({
                    music: false,
                    playlistData: false,
                });
            });
    // Disabled the following rule because I want to use this only on initial render (like didMount)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="musicItemWrapper">
            {
                !musicItemData.music ?
                    <Placeholder minHeight="125px" />
                    :
                    <MusicItem
                        music={musicItemData.music}
                        showDownloadButton={props.showDownloadButton}
                        // playlist
                        playlistType="singleMusicItem"
                        playlistData={musicItemData.playlistData}
                        musicIndex={0}
                    />
            }
        </div>
    );
};

MusicItemShortcodeComponent.propTypes = exact({
    getMusicData: PropTypes.func.isRequired,
    artistSlug: PropTypes.string.isRequired,
    musicSlug: PropTypes.string.isRequired,
    showDownloadButton: PropTypes.bool,
});

export default MusicItemShortcodeComponent;
